import { render, staticRenderFns } from "./LLInputSuggestionsOld.vue?vue&type=template&id=b5310bbc&scoped=true"
import script from "./LLInputSuggestionsOld.vue?vue&type=script&lang=js"
export * from "./LLInputSuggestionsOld.vue?vue&type=script&lang=js"
import style0 from "./LLInputSuggestionsOld.vue?vue&type=style&index=0&id=b5310bbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5310bbc",
  null
  
)

export default component.exports